var map = {
	"./A.mp3": [
		755,
		755
	],
	"./B.mp3": [
		732,
		732
	],
	"./C.mp3": [
		501,
		501
	],
	"./D.mp3": [
		491,
		491
	],
	"./E.mp3": [
		734,
		734
	],
	"./F.mp3": [
		366,
		366
	],
	"./G.mp3": [
		94,
		94
	],
	"./H.mp3": [
		190,
		190
	],
	"./I.mp3": [
		565,
		565
	],
	"./J.mp3": [
		375,
		375
	],
	"./K.mp3": [
		645,
		645
	],
	"./L.mp3": [
		740,
		740
	],
	"./M.mp3": [
		59,
		59
	],
	"./N.mp3": [
		671,
		671
	],
	"./O.mp3": [
		26,
		26
	],
	"./P.mp3": [
		186,
		186
	],
	"./Q.mp3": [
		743,
		743
	],
	"./R.mp3": [
		742,
		742
	],
	"./S.mp3": [
		519,
		519
	],
	"./T.mp3": [
		826,
		638
	],
	"./U.mp3": [
		56,
		56
	],
	"./V.mp3": [
		350,
		350
	],
	"./W.mp3": [
		851,
		851
	],
	"./X.mp3": [
		942,
		942
	],
	"./Y.mp3": [
		57,
		57
	],
	"./Z.mp3": [
		71,
		71
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 620;
module.exports = webpackAsyncContext;